import { IProgram, IProgramMap } from "../interfaces";
import { IProgramFilter } from "../interfaces/campaign-filter";
import { IStateMapGeneric } from "../interfaces/state-map";
import { IAction } from "../interfaces/store-action";
import { ITheme } from "../interfaces/theme";

/* SET PROGRAMS */
export type ISetProgramsPayload = {
  programMap: IProgramMap;
  allProgramsLoaded?: boolean;
};
type ISetProgramsAction = IAction<
  "PROGRAM",
  "SET PROGRAMS",
  ISetProgramsPayload
>;
export function setProgramsAction(
  payload: ISetProgramsPayload
): ISetProgramsAction {
  return {
    store: "PROGRAM",
    type: "SET PROGRAMS",
    payload,
  };
}

type ICheckInProgramAction = IAction<
  "PROGRAM",
  "CHECK_IN",
  { campaignId: string },
  IStateMapGeneric<"campaignId">
>;
export function checkInProgramAction(payload: {
  campaignId: string;
}): ICheckInProgramAction {
  return {
    store: "PROGRAM",
    type: "CHECK_IN",
    payload,
  };
}
type IAcceptProgramAction = IAction<
  "PROGRAM",
  "ACCEPT",
  { campaignId: string },
  IStateMapGeneric<"campaignId">
>;
export function acceptProgramAction(payload: {
  campaignId: string;
}): IAcceptProgramAction {
  return {
    store: "PROGRAM",
    type: "ACCEPT",
    payload,
  };
}

/* SET PROGRAM */
export type ISetProgramPayload = {
  program: IProgram;
};
type ISetProgramAction = IAction<"PROGRAM", "SET PROGRAM", ISetProgramPayload>;
export function setProgramAction(
  payload: ISetProgramPayload
): ISetProgramAction {
  return {
    store: "PROGRAM",
    type: "SET PROGRAM",
    payload,
  };
}

/* HOOK ACTIONS */

/* LOAD PROGRAMS */
export type ILoadProgramsPayload = { filter?: IProgramFilter };
type ILoadProgramsAction = IAction<
  "PROGRAM",
  "LOAD PROGRAMS",
  ILoadProgramsPayload
>;
export function loadPrograms(
  payload: ILoadProgramsPayload
): ILoadProgramsAction {
  return {
    store: "PROGRAM",
    type: "LOAD PROGRAMS",
    payload,
  };
}

export type IProgramActions =
  | ISetProgramsAction
  | ISetProgramAction
  | ILoadProgramsAction
  | IAcceptProgramAction
  | ICheckInProgramAction;
